const SHORT_SLUG_MAX_LENGTH = 48

export const buildCleanShortSlugFromCampaignKey = (campaignKey = '') => {
  if (!campaignKey) {
    return ''
  }

  const base = campaignKey
    .replace(/_/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')

  if (!base) {
    return ''
  }

  return base.slice(0, SHORT_SLUG_MAX_LENGTH).replace(/-+$/g, '')
}

export default buildCleanShortSlugFromCampaignKey
